import React, {useState, useRef, useEffect} from 'react'
import UserIcon from './UserIcon';
import { CgProfile } from 'react-icons/cg';
import { IoMdLogIn, IoMdLogOut } from 'react-icons/io';
import { urlFor } from '../lib/client';
import {useStateContext} from '../context/StateContext';
import { useOfflineContext } from '../context/OfflineContext';
import { MdOutlinePhonelinkErase } from "react-icons/md";
import { FiRefreshCw } from "react-icons/fi";
import { useRouter } from 'next/router';
import { MdOutlineOnlinePrediction } from "react-icons/md";

import Swal from 'sweetalert2';
import { successAlert } from '../lib/utils';

import localforage from "localforage";
import { useAuthContext } from '../hooks/useAuthContext';

localforage.config({
    name: 'Relyon',
    isPersistent: true
})


const ProfileMenu = () => {

    const { user, dispatch } = useAuthContext()
    const router = useRouter()
    const [open, setOpen] = useState(false);
    const {sUser, setSUser, customer, setCustomer, manualOffline, setManualOffline, site} = useStateContext()
    const {offlineData} = useOfflineContext()
    const logout = async() => {
      // remove user from storage
      await localforage.clear();
      localStorage.removeItem('user')
      // dispatch logout action
      dispatch({ type: 'LOGOUT' })
     
    }
    const reset = async () => {
      console.log("resetting user", user)
      try {
        // Store current user data before clearing
        const currentUser = user
        const currentSUser = sUser
        const currentCustomer = customer

        // Clear localforage
        await localforage.clear()

        // Re-dispatch LOGIN first to ensure auth state is maintained
        dispatch({ type: 'LOGIN', payload: currentUser })
        
        // Then restore the rest of the user context
        setSUser(currentSUser)
        setCustomer(currentCustomer)

        successAlert("Presidio resettato")
        router.push('/')
      } catch (error) {
        console.error("Reset error:", error)
        successAlert("Errore durante il reset")
      }
    }

    let menuRef = useRef();

    useEffect(() => {
        let handler = (e)=>{
          if(!menuRef.current.contains(e.target)){
            setOpen(false);
            //console.log(menuRef.current);
          }      
        };
    
        document.addEventListener("mousedown", handler);
        
    
        return() =>{
          document.removeEventListener("mousedown", handler);
        }
    
      });

      const onMenuClick = () => {
        setOpen(!open)
        //console.log("pic:",user.picture)
      }
      const height = !open && {height:"10px"}
    
  return (
  <div style={{...height, zIndex:2000}} ref={menuRef}>
      <div style={{display:"flex", justifyContent:"right"}}>
          <UserIcon
          style={{marginTop:"8px"}}
          onClick={onMenuClick}
          />
    </div>
    <div className={`dropdown-menu-profile ${open? 'active' : 'inactive'}`} >
      
      <ul>
      {!manualOffline &&
        <>
        {!user ? 
        <LogoutItem icon = {<IoMdLogIn/>} text = {"Log in"} link = {'/api/auth/login'}/>
       : <LogoutItem onClick = {logout} icon = {<IoMdLogOut/>} text = {"Log out"} link = {'/'}/> 
        } 

          <DropdownItem 
            //alert 
            //alertMessage = {`${offlineData?.length}`} 
            fn = {()=>{}} 
            reload = {true}
            icon = {<FiRefreshCw/>} 
            //alertTitle = {"RICARICO PAGINA"}
            text = {"Ricarica"}
          /> 

        <DropdownItem 
          alert 
          alertMessage = {"I DATI DEL PROGRAMMA SALVATI SU QUESTO DIPOSITIVO, INCLUSI I DATI OFFLINE, VERRANNO RESETTATI E POTREBBERO ANDARE PERSI"} 
          fn = {reset} 
          icon = {<MdOutlinePhonelinkErase/>} 
          alertTitle = {"ATTENZIONE!!"}
          router = {router}
          link = {"/"}
          text = {"!Reset"}
          //reload = {true}
          
          /> 
        </>
        }
        {  site && <DropdownItem 
          fn = {()=>{
            setManualOffline(!manualOffline)
            onMenuClick()
          }} 
          icon = {<MdOutlineOnlinePrediction/>} 
          text = {manualOffline? "Online" : "Offline"}
         /> }
        v 2.1.1

{/*         <DropdownItem 
        alert 
        alertMessage = {`${offlineData?.length}`} 
        fn = {()=>{
          localforage.clear(); 
          }} 
        icon = {<MdOutlinePhonelinkErase/>} 
        alertTitle = {"NUMERO DATI PRESENTI"}
        text = {"Dati"} /> */}



      </ul>
    </div>
  </div>

  )
}

function LogoutItem(props){
    
/*   const onLogoutClick = () => {
    console.log("logged out")
    //localforage.clear();
  } */

    return(
      <li onClick={props.onClick} className = 'dropdownItem-profile'>
       {props.img && <img src={props.img}></img>}
       {props.icon && props.icon}
        <a href={props.link}>{props.text} </a> 
      </li>
    );
  }

  function DropdownItem(props){
    
    const onMenuClick = () => {
      
      const alert = () => {
        Swal.fire({
            title:  props?.alertTitle,
            text: props?.alertMessage,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: "SI', PROSEGUI",
            cancelButtonText: "ANNULLA"
          }).then((result) => {
            if (result.isConfirmed) {
              props?.fn()
              if(props?.link){
                props?.router.push({pathname: props?.link}).then(()=> window.location.reload())
                
              }
              else if(props?.reload){
                window.location.reload();
              }
            }
          })
      }
      if(props?.alert){
        alert()
      } else {
        props?.fn()
        if(props?.link){
          props?.router.push({pathname: props?.link}).then(()=> window.location.reload())
        }
        else if(props?.reload){
          window.location.reload();
        }
      }
   
      //console.log("logged out")
      
    }
   
      return(
          <li onClick={onMenuClick} className = 'dropdownItem-profile'>
          {props.img && <img src={props.img}></img>}
          <div style={{marginRight:"8px"}}>
           {props.icon && props.icon}
          </div>
         
          {props.text}
          </li>
      
      
      );
    }

export default ProfileMenu

/*
        <DropdownItem img = {edit} text = {"Edit Profile"}/>
        <DropdownItem img = {inbox} text = {"Inbox"}/>
        <DropdownItem img = {settings} text = {"Settings"}/>
        <DropdownItem img = {help} text = {"Helps"}/>
        <DropdownItem img = {logout} text = {"Logout"}/>

                {user ? 
            <a href="/api/auth/logout">Logout</a> :             
            <a href='/api/auth/login'>login</a> }

            <h3>Michael<br/><span>Bianco</span></h3>
*/
